import { MrbBaseRouteStore } from "mrb/core";
import { PortalAnalyticsService } from "common/services";

class RegisteredUsersActivityRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(PortalAnalyticsService);
    }

    async getRegisteredUsersActivity(filter, abortController) {
        const response = await this.service.getRegisteredUsersActivity(filter, abortController);
        return response.data;
    }

    async getRegisteredUsersSummary(filter, abortController) {
        const response = await this.service.getRegisteredUsersSummary(filter, abortController);
        return response.data;
    }
}

export default RegisteredUsersActivityRouteStore;
